import validTransitionPaths from '../../../views/TransitionView/config';

export default (to, from, next) => {
  if (
    to.params.transitionName
    && validTransitionPaths.includes(to.params.transitionName)
  ) next();
  else next({ path: `/${to.params.locale}/${to.params.path}/` });
};
